import { CommonModule } from "@angular/common";
import { Component, inject, input } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { IonicModule } from "@ionic/angular";
import { LicenseTypes } from "@models/MasterData";
import { TranslateModule, TranslateService } from "@ngx-translate/core";

@Component({
  standalone: true,
  selector: "free-bets-instructions",
  templateUrl: "free-bets-instructions.component.html",
  styleUrls: ["free-bets-instructions.component.scss"],
  imports: [IonicModule, CommonModule, TranslateModule, ReactiveFormsModule, FormsModule],
})
export class FreeBetsInstructions {
  licenseType = input.required<number>();
  hasFB = input.required<boolean>();
  isFbOnline = input.required<boolean>();
  translate = inject(TranslateService);
  LicenseTypes = LicenseTypes;
  textInfoOnlineColombia = ["fb_sst_txt01", "fb_sst_txt02", "fb_sst_txt03", "fb_sst_txt04", "fb_sst_txt05"];
  textInfoOnlineAllCountries = ["fb_txt_active2", "fb_txt_active3", "fb_txt_active4", "fb_txt_active5"];
}
